import { isFeatureEnabled } from 'owa-feature-flags';

export function isOfflineSyncEnabled() {
    // Sync depends on BroadcastChannel for cross-window coordination
    return (
        self.BroadcastChannel &&
        isFeatureEnabled('fwk-graphql-worker-link') &&
        isFeatureEnabled('fwk-offline-sync')
    );
}
